import "Styles/templates/page.holiday-gift-guide.scss";

import productSliderApp from '../vue/product-slider/index';

productSliderApp()
